// Coercion. Every number and every date entering the kernel comes through
// here, so nothing downstream has to guess what shape it arrived in.

export const MS_PER_DAY = 1000 * 60 * 60 * 24;

// Average month length. Every date-to-months conversion in the app uses this
// same figure, which is why the dashboard, the projection and the review
// estimates agree on how old something is.
export const MS_PER_MONTH = MS_PER_DAY * 30.4375;

/** A stored amount as a number, with anything unparseable read as zero. */
export const num = (value) => {
    const parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
};

/**
 * A stored date as a Date, or null if there isn't one.
 *
 * Dates reach the app in four shapes depending on the path they took: a
 * Firestore Timestamp from the live listener, a `{seconds}` object from a
 * serialized snapshot, an ISO string from a form, or epoch millis from demo
 * data. Every one of them has to work.
 */
export const toDate = (value) => {
    if (!value) return null;
    let date = null;
    if (value instanceof Date) date = value;
    else if (typeof value?.toDate === 'function') date = value.toDate();
    else if (typeof value?.seconds === 'number') date = new Date(value.seconds * 1000);
    else if (typeof value === 'string' || typeof value === 'number') date = new Date(value);
    if (!date || isNaN(date.getTime())) return null;
    return date;
};

/** Fractional months between two dates. Zero if either is missing, or if `to` precedes `from`. */
export const monthsBetween = (fromDate, toDateValue) => {
    const from = toDate(fromDate);
    const to = toDate(toDateValue);
    if (!from || !to) return 0;
    return Math.max(0, (to - from) / MS_PER_MONTH);
};

/** Fractional days between two dates, same conventions. */
export const daysBetween = (fromDate, toDateValue) => {
    const from = toDate(fromDate);
    const to = toDate(toDateValue);
    if (!from || !to) return 0;
    return Math.max(0, (to - from) / MS_PER_DAY);
};

/** Whole months completed — how many payments a schedule has seen, for instance. */
export const monthsElapsed = (fromDate, toDateValue) => Math.floor(monthsBetween(fromDate, toDateValue));
